"use client";

import OpenAIIcon from "@/shared/icons/logos/open-ai.svg";
import NetflixIcon from "@/shared/icons/logos/netflix.svg";
import SpotifyIcon from "@/shared/icons/logos/spotify.svg";
import ClaudeIcon from "@/shared/icons/logos/claude.svg";
import PlaystationIcon from "@/shared/icons/logos/playstation.svg";
import HBOIcon from "@/shared/icons/logos/hbo.svg";
import YoutubeIcon from "@/shared/icons/logos/youtube.svg";
import AppleIcon from "@/shared/icons/logos/apple.svg";
import AirbnbIcon from "@/shared/icons/logos/airbnb.svg";
import BookingIcon from "@/shared/icons/logos/booking.svg";
import TripComIcon from "@/shared/icons/logos/trip-com.svg";
import KayakIcon from "@/shared/icons/logos/kayak.svg";
import ExpediaIcon from "@/shared/icons/logos/expedia.svg";
import AgodaIcon from "@/shared/icons/logos/agoda.svg";
import SkyscannerIcon from "@/shared/icons/logos/skyscanner.svg";
import EmiratesIcon from "@/shared/icons/logos/emirates.svg";
import GoogleIcon from "@/shared/icons/logos/google.svg";
import AdobeIcon from "@/shared/icons/logos/adobe.svg";
import SlackIcon from "@/shared/icons/logos/slack.svg";
import DiscordIcon from "@/shared/icons/logos/discord.svg";
import AmazonIcon from "@/shared/icons/logos/amazon.svg";
import FigmaIcon from "@/shared/icons/logos/figma.svg";
import CanvaIcon from "@/shared/icons/logos/canva.svg";
import DropboxIcon from "@/shared/icons/logos/dropbox.svg";
import { useMemo } from "react";
import { Box } from "@/shared/components/box";

const icons = {
  openai: OpenAIIcon,
  netflix: NetflixIcon,
  spotify: SpotifyIcon,
  claude: ClaudeIcon,
  playstation: PlaystationIcon,
  HBO: HBOIcon,
  youtube: YoutubeIcon,
  apple: AppleIcon,
  airbnb: AirbnbIcon,
  booking: BookingIcon,
  tripCom: TripComIcon,
  expedia: ExpediaIcon,
  agoda: AgodaIcon,
  kayak: KayakIcon,
  skyscanner: SkyscannerIcon,
  emirates: EmiratesIcon,
  google: GoogleIcon,
  adobe: AdobeIcon,
  slack: SlackIcon,
  discord: DiscordIcon,
  amazon: AmazonIcon,
  figma: FigmaIcon,
  canva: CanvaIcon,
  dropbox: DropboxIcon
};

export type ServiceItemProps = {
  type: keyof typeof icons;
};

export const ServiceItem = (props: ServiceItemProps) => {
  const Icon = useMemo(() => {
    return icons[props.type];
  }, [props.type]);

  return (
    <Box className="flex h-full min-h-28 lg:min-h-40">
      <Icon className="m-auto w-28 lg:w-36.5 h-full" />
    </Box>
  );
};
